/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationCompanyMutation from '../graphql/mutations/SaveSimulationCompanyMutation.js';

export const useSaveSimulationCompanyMutation = () => {
  return useCommitMutation(SaveSimulationCompanyMutation, {
    dataProp: 'saveSimulationCompany_M_simulation_company'
  });
};

export default useSaveSimulationCompanyMutation;
